'use strict';

// Constructor
var Header = function() {
    var header = $('.header');
    var body = $('body');
    var menuOpen = $('.header__hamburguer');
    var menuItem = $('.header__menu__item');
    var overlay = $('.header__overlay');

    menuOpen.on('click', function(){
        header.toggleClass('-open');
        body.toggleClass('-hideOverflow');
    });

    menuItem.each(function() {
        var $this = $(this);

        $this.on('click', function(){
            menuItem.removeClass('header__menu__item--open');
            $this.addClass('header__menu__item--open');
            overlay.addClass('header__overlay--visible');
            body.addClass('-hideOverflow');
        });
    });

    overlay.on('click', function(){
        menuItem.removeClass('header__menu__item--open');
        overlay.removeClass('header__overlay--visible');
        body.removeClass('-hideOverflow');
    });

    // Select all links with hashes
    $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .not('[class="js-trigger"]')
    .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top + -160
        }, 1000, function() {});
      }
    }
    });
};

module.exports = Header;
